<template>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Privacy Policy</h5>

          <div v-show="showPreList" class="row col-10 text-right">
            <table class=" vert ">
              <colgroup>
                <col style="width: auto" />
                <col style="width: 33%" />
                <col style="width: 330px" />
                <col style="width: 9%" />
              </colgroup>
              <tr>
                <td>&nbsp;</td>
                <td>
                  <b> {{ $t('sdl.gcrm.privacyPolicy.view.previous') }} &nbsp;&nbsp;</b>
                </td>
                <td class="text-right;">
                  <select class="form-control" style="padding: 0 0 0 10px; width:328px;" @change="changeList()" v-model="preListUrl">
                    <option v-for="(item, index) in preList" 
                    :value="item.url"
                    v-bind:key="index">
                    {{ item.title}}
                  </option>
                  </select>
                </td>
                <td>
                  <button type="button" class="btn btn-info"  @click="goPreUrl()">{{ $t('sdl.board.label.inquery') }}</button>
                </td>
              </tr>
            </table>
              
           
          </div>

        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="privacy-wrap">
          <div class="left">
            <div class="area-tit">Area</div>
            <div class="area-list">
              <div class="form-radio" v-for="area in ppList" :key="area.code" @change="changeArea(area)">
                <input
                  type="radio"
                  :id="area.code"
                  name="radio-area"
                  :value="area.description.url"
                  v-model="selectedSrc"
                />
                <label class="form-radio-label" :for="area.code">{{ getLabel(area) }}</label>
              </div>
            </div>
          </div>
          <div class="right">
              <iframe :src="iframeUrl" id="terms" class="iframe" scrolling="auto"></iframe>
          </div>
          
        </div>
        <div class="row col-12">{{ $t('sdl.gcrm.privacyPolicy.comment') }}
        </div>
      </div>
      
      <div class="modal-footer">
        
        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="$emit('close')">{{ $t('sdl.common.label.close') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { SDLUtil } from '@/utils';
import SDLLocale from '@/mixin/SDLLocale';

export default {
  mixins: [SDLLocale],
  data() {
    return {
      ppList: [],
      selectedSrc: '',
      preList:[],
      showPreList:false,
      preListUrl : '',
      iframeUrl:'',
    };
  },
  mounted() {
    this.ppList = SDLUtil.getCommCodeList({ commCodeTypeId: 'GC_PP_FOOTER' });
    // console.log(this.ppList);
    try {
      this.ppList.forEach(item => {
        if (typeof item.description === 'string') {
          item.description = JSON.parse(item.description);
        }
      });
      
      this.selectedSrc = this.ppList[0].description.url;
      this.iframeUrl = this.selectedSrc;
      // console.log('selectedSrc :: ', this.selectedSrc);
      if( process.env.NODE_ENV === 'local'){
         this.iframeUrl = '/static' + this.selectedSrc;
      }
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    changeArea(area){
      console.log(area.description);
      this.showPreList = false;
      // this.preList.splice(0);
      this.iframeUrl = this.selectedSrc;
      if( process.env.NODE_ENV === 'local'){
         this.iframeUrl = '/static' + this.selectedSrc;
      }
      if(area.description.list && area.description.list.length > 0){
        this.preList = area.description.list;
        this.showPreList = true;
        this.preListUrl = this.preList[0].url;
      }
    },
    changeList() {
      console.log(this.preListUrl);
    },
    goPreUrl(){
      this.iframeUrl = this.preListUrl;
      if( process.env.NODE_ENV === 'local'){
         this.iframeUrl = '/static' + this.preListUrl;
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/popup/PolicyPopup.vue